import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-brand-bg-alt" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-144">
          <h2 className="text-4xl md:text-5xl mb-6 text-brand-dark" data-id="element-145">
            El Verdadero Problema
          </h2>
          <p className="text-xl text-stone-600 max-w-2xl mx-auto" data-id="element-146">
            El problema no es que no sepas cocinar.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-148">
            <div className="bg-red-50 w-12 h-12 rounded-xl flex items-center justify-center mb-6" data-id="element-149">
              <AlertCircleIcon className="w-6 h-6 text-brand-red" data-id="element-150" />
            </div>
            <h3 className="text-2xl mb-4" data-id="element-151">La Trampa del Tiempo</h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-152">
              El problema es que los recetarios tradicionales están hechos para
              gente que tiene tardes libres. En el mundo real, después de un
              turno largo, buscar ingredientes raros y lavar cinco ollas es
              simplemente imposible.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-153">
            <div className="bg-orange-50 w-12 h-12 rounded-xl flex items-center justify-center mb-6" data-id="element-154">
              <TrendingDownIcon className="w-6 h-6 text-brand-accent" data-id="element-155" />
            </div>
            <h3 className="text-2xl mb-4" data-id="element-156">La Fuga de Dinero</h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-157">
              Cada noche que cedes ante la "comida chatarra" por falta de
              tiempo, no solo pierdes salud; estás drenando tu cuenta bancaria
              con gastos hormiga que suman miles de dólares al año.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 bg-stone-900 text-white p-8 rounded-2xl text-center shadow-xl" data-id="element-158">
          <p className="text-xl md:text-2xl font-serif" data-id="element-159">
            Estás atrapado entre el agotamiento extremo y la culpa de no
            alimentar bien a los que más amas.
          </p>
        </motion.div>
      </div>
    </section>;
}